module.exports = __webpack_public_path__ + "img/huiyuan.88e2af76.png";